<template>
  <div class="sky_wrap">
    <div class="sky_btn">
      <div
        v-for="(item, index) in skyList"
        :key="index"
        :class="activeIndex === index ? 'active' : ''"
        class="sky_item"
        @click="changeIndex(index)"
      >
        {{ item.tit }}
      </div>
    </div>
    <div class="sky_content">
      <div class="content_left">
        <div class="left_tit">{{ skyTitle }}</div>
        <div class="left_icon_wrap">
          <div
            v-for="(item, index) in skyImgList"
            :key="index"
            ref="iconItem"
            class="icon_item"
          >
            <i :class="item.src"></i>
            <span v-html="item.txt"></span>
          </div>
        </div>
        <div
          class="left_btn hidden-xs-only"
          @click="handleToDeomo"
        >获取产品演示</div>
      </div>
      <div class="content_right">
        <img
          :src="skycurrentImg"
          alt=""
        />
        <div
          class="left_btn hidden-sm-and-up"
          @click="handleToDeomo"
        >获取产品演示</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeIndex: 0,
      skyTitle:
        '40KW充电模块是电动汽车充电设备的核心，将交流电转为直流电，适用于中小型电动车。支持三相380V AC输入，兼容多种电池，广泛应用于公共充电站、停车场等。高效、可靠，具备多重保护和智能通信功能，推动绿色出行发展。',
      skyImgList: [
        {
          src: '',
          txt: '<span style="font-weight:bold;padding-right:10px;">全方位智能充电安全保护系统</span>完善保护与告警功能，内置泄放与防反灌电路，全方位保障充电安全',
        },
        {
          src: '',
          txt: '<span style="font-weight:bold;padding-right:10px;">智能化通信接口</span>模块支持CAN通信，实现充电桩与后台数据交互，远程监控与故障诊断，提升效率与体验。',
        },
        {
          src: '',
          txt: '<span style="font-weight:bold;padding-right:10px;">高效低耗</span>高效率，低损耗，转换效率达94%-96%，待机功耗＜5W，节能更出色',
        },
      ],
      skycurrentImg: require('../../assets/图片4.png')
    }
  },
  props: {
    skyList: {
      type: Array,
      default: [],
    },
  },
  methods: {
    changeIndex (index) {
      this.activeIndex = index
      switch (this.activeIndex) {
        case 1:
          this.skyTitle =
            '60kW液冷充电模块通过高效散热、紧凑设计、智能管理三大核心优势，解决了高功率充电中的散热瓶颈和空间限制问题，是未来超快充网络的关键技术。随着电动车电池容量和充电速度的提升，液冷技术将成为大功率充电设备的主流选择。'
          this.skyImgList = [
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">高效散热，精准控温</span>液冷技术高效散热，温度均匀，适应恶劣环境，功率密度达传统风冷2-3倍，稳定可靠',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">全封闭设计，IP67防护等级</span>低温运行环境（＜50°C）大幅延长IGBT、电容等核心器件的使用寿命......',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">智能化通信接口</span>内置传感器实时监控，智能调功，兼容BMS，适配400V/800V平台，支持远程运维与预警',
            },
          ]
          this.skycurrentImg = require('../../assets/图片41.jpg')
          break
        case 2:
          this.skyTitle =
              'ZN-FZ01 新一代双口插座型无线智能网关，集成 4G 网关与充电插座，无线管理多达 20 个充电插座，4G 直连云平台。自带双路独立插口，每路 2200W 输出，支持扫码 + NFC 刷卡支付，安全便捷，高性价比，适配小区、物业、停车场等充电运营场景。'
          this.skyImgList = [
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">集成一体化设计</span>集4G网关与智能充电插座于一体，无需额外配置网关，有效降低部署成本。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">分布式灵活管控</span>采用无线局域网管理，单台最多可管控 20 个智能充电插座，适配多场景分布式充电布局，扩容便捷。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">多元便捷支付</span>支持手机扫码+NFC 刷卡双支付方式，操作简便，满足不同人群使用需求。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">稳定云端运维</span>4G网络直连云平台，数据传输稳定，实现设备远程智能管理，提升运维效率。',
            }
          ]
          this.skycurrentImg = require('../../assets/dsll10cd.png')
          break
        case 3:
          this.skyTitle =
              '高速集中式两轮10路充电桩采用一体化主机设计，可同时为10辆两轮车提供安全、稳定的充电服务。设备具备过载、短路、漏电等多重保护，安装布线简单，管理统一便捷，适用于小区、园区、商场等集中停放场景。'
          this.skyImgList = [
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">动态精准断电保护</span>自动识别电池功率并智能调整断电策略，有效保护电池，延长使用寿命。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">多重安全防护机制</span>内置烟感、温度传感器和微波检测，结合过流、欠压保护，可及时监测并预警火灾、过载等风险。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">升级体验设计</span>配备语音播报专利，可根据使用场景灵活配置提示。',
            }
          ]
          this.skycurrentImg = require('../../assets/gsll10cd.jpg')
          break
        case 4:
          this.skyTitle =
            '直流充电堆由整流模块、充电模块、智能控制系统等构成，将交流电转为直流电，通过智能调控与冷却系统实现高效、安全的大功率充电。'
          this.skyImgList = [
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">高效智能充电模块</span>按需调入、零待机功耗、精准调速、恒功率输出',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">全矩阵智能充电系统</span>按需分配功率＞40kW，单终端输出500kW，支持自动识别与容量管控',
            },
          ]
          this.skycurrentImg = require('../../assets/zljqcd.jpg')
          break
        case 5:
          this.skyTitle =
            '采用先进液冷技术，实现高效散热与温度均匀控制，支持超高功率充电，大幅缩短充电时间。其紧凑设计适应高温、高湿等恶劣环境，功率密度达传统风冷2-3倍，同时内置智能监控与保护功能，兼容多种平台，支持远程运维与故障预警。'
          this.skyImgList = [
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">超大功率充电</span>支持 ChaoJi标准，缩短充电等待时间，解决充电焦虑，提高用户充电体验',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">智能调节温度高效散热</span>智能调节系统温度，通过液冷散热方式，封闭免维护，提升产品稳定与可靠性',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">超充系统：800KW全功率，16枪智能调配</span>全功率充800KW，单枪最高250KW，智能调配，最大16枪 ',
            },
          ]
          this.skycurrentImg = require('../../assets/ylcd.png')
          break
        default:
          this.skyTitle =
            '40KW充电模块是电动汽车充电设备的核心，将交流电转为直流电，适用于中小型电动车。支持三相380V AC输入，兼容多种电池，广泛应用于公共充电站、停车场等。高效、可靠，具备多重保护和智能通信功能，推动绿色出行发展。'
          this.$refs.iconItem.map(v => {
            v.style.width = '90%'
          })
          this.skyImgList = [
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">全方位智能充电安全保护系统</span>完善保护与告警功能，内置泄放与防反灌电路，全方位保障充电安全',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">智能化通信接口</span>模块支持CAN通信，实现充电桩与后台数据交互，远程监控与故障诊断，提升效率与体验。',
            },
            {
              src: '',
              txt: '<span style="font-weight:bold;padding-right:10px;">高效低耗</span>高效率，低损耗，转换效率达94%-96%，待机功耗＜5W，节能更出色',
            },
          ]
          this.skycurrentImg = require('../../assets/图片4.png')
          break
      }
    },
    handleToDeomo () {
      this.$router.push('/demo')
    }
  },
}
</script>

<style lang="scss" scoped>
.sky_wrap {
  width: 70%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;
  @media screen and (max-width: 768px) {
    width: 95%;
    background: #f7f7f7;
  }

  .sky_btn {
    width: 100%;
    display: flex;

    .sky_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 13px;
      }
    }

    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;

      &::before {
        content: "▲";
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }

  .sky_content {
    width: 100%;
    display: flex;
    padding: 30px;
    justify-content: center;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }

    .content_left {
      width: 40%;
      @media screen and (max-width: 768px) {
        width: 100%;
      }

      .left_tit {
        color: #2d3937;
        font-size: 20px;
        min-height: 90px;
        line-height: 22px;
        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          padding: 10px 20px;
          color: #646464;
        }
      }

      .left_icon_wrap {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 30px;
        @media screen and (max-width: 768px) {
          justify-content: center;
        }

        .icon_item {
          width: 90%;
          height: 50px;
          @media screen and (max-width: 768px) {
            height: 50px;
          }

          i {
            color: #7bbde3;
            @media screen and (max-width: 768px) {
              font-size: 20px;
            }
          }

          span {
            color: #646464;
            font-size: 17px;
            @media screen and (max-width: 768px) {
              font-size: 14px;
            }
          }
        }
      }

      .left_btn {
        width: 150px;
        height: 40px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
      }
    }

    .content_right {
      width: 40%;
      @media screen and (max-width: 768px) {
        width: 100%;
        text-align: center;
      }
      text-align: right;

      img {
        margin-top: 30px;
        width: 80%;
      }

      .left_btn {
        width: 180px;
        height: 50px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
        cursor: pointer;
        @media screen and (max-width: 768px) {
          width: 120px;
          height: 35px;
          font-size: 14px;
          border-radius: 20px;
          margin: 20px auto;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
